export default __webpack_public_path__ + "static/media/DNo.39-2.28d89474.jpg";